import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

// Inject bearer token for authenticated endpoints (admin APIs + any /auth/* except login).
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("kiki_admin_token");
  const url = cfg.url || "";
  const needsAuth = url.startsWith("/admin") || (url.startsWith("/auth/") && !url.startsWith("/auth/login"));
  if (token && needsAuth) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
